// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-link {
  font-size: 1.6rem;
  line-height: 1.9rem;
  color: var(--primary);
}
.app-link.small {
  font-size: 1.2rem;
  line-height: 1.4rem;
}
.app-link:hover, .app-link:active {
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/shared/link/link.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,mBAAA;EACA,qBAAA;AACF;AACE;EACE,iBAAA;EACA,mBAAA;AACJ;AAEE;EAEE,0BAAA;AADJ","sourcesContent":[".app-link {\n  font-size: 1.6rem;\n  line-height: 1.9rem;\n  color: var(--primary);\n\n  &.small {\n    font-size: 1.2rem;\n    line-height: 1.4rem;\n  }\n\n  &:hover,\n  &:active {\n    text-decoration: underline;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
